var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.appLoaded)?_c('Spinner'):_c('div',[_c('Header'),_c('router-view'),_c('Footer',{ref:"FooterRef"}),_c('CookieConsentBanner',{on:{"accepted":_vm.onConsentAccepted}}),_c('vue-toastr',{ref:"toastr"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }